import React from 'react';
import styled from 'styled-components';
import { CandidateProgressBar } from '../ProgressBar';
import { CandidatePhoto } from '../CandidatePhoto';
import Typography from "@mui/material/Typography";
import { ChevronRightButton } from '../lower-order';
import {onClickOrLink} from "../../app/util";
import CircularProgress from '@mui/material/CircularProgress';
import Checkbox from '@mui/material/Checkbox';

import { ReactComponent as WarningIcon } from '../../images/yellow-warning.svg';
import { ReactComponent as GreenCheck } from '../../images/green-check.svg';
/*
*  A preview tile used within the RaceDetail page. Displays a candidate's
*  name, photo, progress, and sync status
*/

const CandidatePreviewTile = ({
  candidate,
  onClick,
  showQualifyingStatus,
  isProcessing = false,
  selectable = false,
  selected = false,
  onToggleSelect,
  runningMates,
  runningMateCandidate,
}) => {

  const { _id, stagingDraft, workflow = {}, party, coveragePlan, qualified } = candidate;
  const name = stagingDraft?.name || candidate.name || '';
  const photoPathFace = stagingDraft?.photoPathFace || candidate.photoPathFace;
  const progress = stagingDraft?.progress || candidate.progress || 0;
  const synced = stagingDraft?.synced || candidate.synced;
  const runningMateDraft = runningMateCandidate?.stagingDraft;
  const runningMateName = runningMateCandidate?.stagingDraft?.name || runningMateCandidate?.name;
  const runningMatePhoto = runningMateDraft?.photoPathFace || runningMateCandidate?.photoPathFace;
  const runningMateParty = runningMateCandidate?.party;
  const runningMateProgress = runningMateDraft?.progress || runningMateCandidate?.progress || 0;
  const runningMateWorkflow = runningMateCandidate?.workflow || {};

  let qualifiedStatus = null;
  if(showQualifyingStatus && !isProcessing) { 
    if (qualified === 'yes') {
      qualifiedStatus = 'Qualified';
    } else if (qualified === 'no') {
      qualifiedStatus = 'Not qualified';
    } else if(qualified === 'tbd') {
      qualifiedStatus = 'Qualification pending';
    }
  }
  const handleToggleSelect = (event) => {
    event.stopPropagation();
    if (onToggleSelect) {
      onToggleSelect();
    }
  };

  return (
    <CandidatePreviewInner
      {...(
        Boolean(onClick) ? onClickOrLink(onClick) : {}
      )}
      clickable={Boolean(onClick) ? 1 : 0}
    >
      {
        selectable
          ? (
            <Checkbox
              size="small"
              checked={selected}
              onClick={handleToggleSelect}
            />
          )
          : <div />
      }
      <CandidatePhoto style={{ height: '36px', width: '36px' }} src={photoPathFace}/>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0px'}}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Typography variant={'body1'} style={{ fontWeight: 'bold', textDecoration: 'none' }}>{name} {party ? `(${party})` : ''}</Typography>
          {isProcessing && (
            <CircularProgress size={16} style={{ color: '#453DB7' }} />
          )}
        </div>
        {
          showQualifyingStatus && qualifiedStatus &&
          <Typography variant={'body2'} style={{ textDecoration: 'none', opacity: 0.7 }}>{qualifiedStatus}</Typography>
        } 
      </div>
      <div />
      {
        !isProcessing && coveragePlan === 'auto-coverage' &&
        <Typography variant={'body1'} style={{ textDecoration: 'none' }}>
          {workflow.status === 'draft' && 'Draft'}
          {workflow.status === 'references-added' && workflow.scrapingDetails.infoToScrape && 'Awaiting profiler'}
          {(
            workflow.status === 'auto-profile-created' || 
            (workflow.status === 'references-added' && !workflow.scrapingDetails.infoToScrape) 
          ) && 'Awaiting review'}
          {workflow.status === 'auto-profile-reviewed' && 'Awaiting final review'}
        </Typography>
      }
      {isProcessing && <div />}
      {!isProcessing && (
        <>
          <CandidateProgressBar percentage={progress*100} color='#99D266' backgroundColor='#DDDDDD' candidate={stagingDraft || candidate}/>
          <SyncStatus style={{ justifySelf: 'center' }} data-tip={
            (synced && workflow.status !== 'draft')
              ? 'All changes are live'
              : 'There are some changes that<br/>have not been reviewed or published.'
          }>
            {
              (synced && workflow.status !== 'draft')
                ? <GreenCheck />
                : <WarningIcon />
            }
          </SyncStatus>
          <ChevronRightButton style={{ justifySelf: 'right' }}/>
        </>
      )}
      {isProcessing && (
        <>
          <div />
          <div />
          <div />
        </>
      )}
      {
        runningMates?.enabled &&
        <RunningMateRow>
          {
            runningMateCandidate
            ?
              <>
                <div />
                <CandidatePhoto style={{ height: '24px', width: '24px', marginLeft: '8px' }} src={runningMatePhoto}/>
                <div >
                  <Typography variant={'body1'} style={{ fontWeight: 'bold', textDecoration: 'none' }}>
                    {runningMateName} {runningMateParty ? `(${runningMateParty})` : ''}
                  </Typography>
                  <Typography variant={'body2'} style={{ textDecoration: 'none', opacity: 0.7, marginTop: '-4px' }}>
                    Running mate
                  </Typography>
                </div>
                <div />
                {
                  runningMateCandidate.coveragePlan === 'auto-coverage'
                  ?
                    <Typography variant={'body1'} style={{ textDecoration: 'none' }}>
                      {runningMateWorkflow.status === 'draft' && 'Draft'}
                      {runningMateWorkflow.status === 'references-added' && runningMateWorkflow.scrapingDetails?.infoToScrape && 'Awaiting profiler'}
                      {(
                        runningMateWorkflow.status === 'auto-profile-created' ||
                        (runningMateWorkflow.status === 'references-added' && !runningMateWorkflow.scrapingDetails?.infoToScrape)
                      ) && 'Awaiting review'}
                      {runningMateWorkflow.status === 'auto-profile-reviewed' && 'Awaiting final review'}
                    </Typography>
                  :
                    <div />
                }
                <CandidateProgressBar
                  percentage={runningMateProgress*100}
                  color='#99D266'
                  backgroundColor='#DDDDDD'
                  candidate={runningMateDraft || runningMateCandidate}
                />
                <div />
                <div />
              </>
            :
              <RunningMateEmpty>
                <Typography variant={'body2'} style={{ textDecoration: 'none', opacity: 0.7 }}>
                  No running mate set
                </Typography>
              </RunningMateEmpty>
          }
        </RunningMateRow>
      }
    </CandidatePreviewInner>
  )
}

const CandidatePreviewInner = styled.div`
  padding: 8px 16px;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 40px 50px auto 1fr 150px 100px 50px 50px;
  align-items: center;
  border-bottom: solid 1px #EEEEEE;
  text-decoration: none;
  
  p {
    text-decoration: none;
  }
`

const SyncStatus = styled.div`
  color: #22034F;
  ${props => props.theme.font.bold}
  font-size: 14px;
  
  svg {
    width: 24px;
    height: 24px;
  }
`;

const RunningMateRow = styled.div`
  grid-column: 1 / -1;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 40px 50px auto 1fr 150px 100px 50px 50px;
  align-items: center;
`;

const RunningMateEmpty = styled.div`
  grid-column: 3 / -1;
`;

export { CandidatePreviewTile };
